<template>
  <SolutionPageLayout title="Government" section="Sectors">
    <p>
      Government events demand strong governance, accessibility, and clear audit trails across registration, communications, and delegate data.
    </p>
    <p>
      Entegy is built for high-trust environments: consistent branding, controlled access, and operational tooling that scales from briefings to large public conferences.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
